const { addDays } = require('date-fns')

const APPLICATION_STATUS = {
  NONE: 'none',
  PENDING: 'pending',
  EXPIRED: 'expired',
  APPROVED: 'approved'
}
const EXPIRES_IN_DAYS = 2

/**
 * @param {Object} creditApplication
 * @param {Date} creditApplication.submitted_at
 * @param {Object} creditApplication.data
 * @param {string} creditApplication.location_id
 * @param {number | null} loanLimit
 * @returns {{ status: string, application: Object | null }}
 */
function getApplicationStatus (creditApplication, loanLimit) {
  let status = APPLICATION_STATUS.NONE
  if (creditApplication) {
    const expirationDate = addDays(new Date(), EXPIRES_IN_DAYS)
    if (creditApplication.submitted_at < expirationDate) {
      status = APPLICATION_STATUS.PENDING
    } else {
      status = APPLICATION_STATUS.EXPIRED
    }
  }
  if (loanLimit) {
    status = APPLICATION_STATUS.APPROVED
  }
  return { status, application: creditApplication }
}

module.exports = { getApplicationStatus, APPLICATION_STATUS }
